//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import ReportStatusWatcher from '@/components/reports/ReportStatusWatcher'

/**
 * A layout for the one page that is an app surface rather than a document.
 *
 * The chat wants every pixel below the nav: results come back as wide tables
 * and charts, and the default layout spends that space on a page banner, a
 * reading-width container and a footer, leaving the conversation in a short
 * scrolling box. So this layout drops all three and hands the row below the
 * nav to the page, which fills it.
 *
 * There is deliberately no <Footer> and no <AssistantBubble> here: a footer
 * below a viewport-height chat only creates a page scrollbar with nothing to
 * scroll to, and the bubble would be a second chat session on the page that
 * already has one.
 */
export default {
  name: 'AssistantLayout',
  components: {
    ReportStatusWatcher
  },
  computed: {
    ...mapGetters({
      error: 'global/networkError',
      stack: 'global/networkErrorStack',
      isDesktop: 'breakpoints/desktop',
      isMobile: 'breakpoints/mobile',
      navOpen: 'global/navOpen'
    }),
    showError () {
      return this.error && this.error?.info?.status !== 401
    }
  },
  mounted () {
    this.watchBreakpoints()
  },
  methods: {
    ...mapActions({
      watchBreakpoints: 'breakpoints/watch'
    })
  }
}
